import Vue from 'vue/dist/vue.esm.js'
import '../../plugins/textNodeText'
import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/locales/bootstrap-datepicker.ja.min'

const d = document

const is_input = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_input')
const is_confirm = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_confirm')
const is_finish = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_complete')

const init = () => {
  const template = d.querySelector('#input')
  const templateDOM = new DOMParser().parseFromString( template.innerHTML, 'text/html' )
  const makeConfirm = (name,key,label=true) => {
    if( is_confirm ){
      const $input = $(`input[type="hidden"][name="${name}"]`, templateDOM)
      if( $input.length == 0){
        const ret = `<span>{{ formdata.${key} }}</span>`
        ret + $('<input>',{type:'hidden',name:name})[0]
        $(`[name="__children[${name}][]"]:eq(0)`,templateDOM).before( ret )
      }
      $input.each( (i,input) => {
        const $input = $(input)
        if( i > 0 ) {
          $input.parent().remove()
          return false
        }
        let confirmTxt = $input.parent().textNodeText().trim()
        $input.attr('old-value', $input.val() )
        if(label) $input.removeAttr('value')
        $input.attr(':value',(key == 'is_child2')? key: `formdata.${key}`)
        if(label) $input.parent().html( (i,elm) => elm.replace(confirmTxt, `<span>{{ formdata.${key} }}</span>`) )
      })
    }
    else return false
  }
  const checkConfirm = (name,key,label=true) => {
    if( is_input ) return false
    let $input = $(`input[type="hidden"][name="${name}[data]"]`, templateDOM)
    if( $input.length == 0 ){
      const hidden = $('<input>',{ type: 'hidden', name: name+'[data]' })
        .prependTo( $(`[name="__children[${name}][]"]`, templateDOM ).parent() )
      $input = hidden
    }
    let confirmTxt = $input.parent().textNodeText().trim()
    $input.attr('old-value', $input.val() )
    if(label) $input.removeAttr('value')
    $input.attr(':value',`formdata.${key}`)
    if(label) $input.parent().html( (i,elm) => elm.replace(confirmTxt, `<span>{{ formdata.${key} }}</span>`) )
  } 


  // 状態
  if( is_input ){
    $('input[type="hidden"][name="is_child2"]', templateDOM )
      .each( (i,obj) => obj.setAttribute(':value', 'is_child2' ) )
  }
  makeConfirm( 'is_child2', 'is_child2', false)

  // １人目：教材について
  $('select[name="月刊ポピー"]', templateDOM )
    .each( (i,obj) => obj.setAttribute('v-model', 'formdata.popy' ) )

  makeConfirm( '月刊ポピー', 'popy' )
  checkConfirm( 'ポピーKidsEnglish', 'pke' )
  $('input[name="ポピーKidsEnglish[data][]"][type=checkbox]', templateDOM )
    .each( (i,obj) => obj.setAttribute('v-model', 'formdata.pke' ) )

  // １人目：お子様について
  makeConfirm( 'お名前-1', 'name_1' )
  makeConfirm( 'お名前-2', 'name_2' )
  makeConfirm( 'ふりがな-1', 'furi_1' )
  makeConfirm( 'ふりがな-2', 'furi_2' )
  makeConfirm( '生年月日', 'birthday' )
  makeConfirm( '学校種別', 'school_type' )
  makeConfirm( 'お子さまの園名・学校名', 'school_name' )
  if( is_input ){
    $('input[type="hidden"][name="小・中学校"]', templateDOM )
      .each( (i,obj) => obj.setAttribute('v-model', 'formdata.school_suffix' ) )
  }
  makeConfirm( '小・中学校', 'school_suffix', false)

  // ２人目：教材について
  $('select[name="c2-月刊ポピー"]', templateDOM )
    .each( (i,obj) => obj.setAttribute('v-model', 'formdata.c2popy' ) )

  makeConfirm( 'c2-月刊ポピー', 'c2popy' )
  checkConfirm( 'c2-ポピーKidsEnglish', 'c2pke' )
  $('input[name="c2-ポピーKidsEnglish[data][]"][type=checkbox]', templateDOM )
    .each( (i,obj) => obj.setAttribute('v-model', 'formdata.c2pke' ) )

  // ２人目：お子様について
  makeConfirm( 'c2-お名前-1', 'c2name_1' )
  makeConfirm( 'c2-お名前-2', 'c2name_2' )
  makeConfirm( 'c2-ふりがな-1', 'c2furi_1' )
  makeConfirm( 'c2-ふりがな-2', 'c2furi_2' )
  makeConfirm( 'c2-生年月日', 'c2birthday' )
  makeConfirm( 'c2-学校種別', 'c2school_type' )
  makeConfirm( 'c2-お子さまの園名・学校名', 'c2school_name' )
  if( is_input ){
    $('input[type="hidden"][name="c2-小・中学校"]', templateDOM )
      .each( (i,obj) => obj.setAttribute('v-model', 'formdata.c2school_suffix' ) )
  }
  makeConfirm( 'c2-小・中学校', 'c2school_suffix', false)

  // 保護者さまについて
  makeConfirm( '保護者-お名前-1', 'p_name_1' )
  makeConfirm( '保護者-お名前-2', 'p_name_2' )
  makeConfirm( '保護者-ふりがな-1', 'p_furi_1' )
  makeConfirm( '保護者-ふりがな-2', 'p_furi_2' )
  makeConfirm( '郵便番号', 'zip' )
  makeConfirm( '都道府県', 'pref' )
  makeConfirm( '市区町村番地', 'addr' )
  makeConfirm( '建物名部屋番号', 'bldg' )
  makeConfirm( 'メール', 'email' )
  makeConfirm( '電話番号', 'phone' )

  // アンケート
  $('input[name="アンケート"][type=radio]', templateDOM )
    .each( (i,obj) => obj.setAttribute('v-model', 'formdata.enquete' ) )
  makeConfirm( 'アンケート', 'enquete' )
  makeConfirm( '紹介者名', 'popy_agent' )

  template.innerHTML = templateDOM.body.outerHTML
}

if( is_input || is_confirm ) init()

export default Vue.component( 'inputform', {
  template: is_finish? '#finish': '#input',
  props:{
    is_input: Boolean,
    is_confirm: Boolean,
    is_finish: Boolean,
    is_initial: Boolean,
    is_child2: Boolean,
    formdata: Object
  },
  data () {
    return {
      inputs : [
        // １人目：教材について
        [ '月刊ポピー', 'popy' ],
        [ 'ポピーKidsEnglish[data]', 'pke' ],
  
        // １人目：お子様について
        [ 'お名前-1', 'name_1' ],
        [ 'お名前-2', 'name_2' ],
        [ 'ふりがな-1', 'furi_1' ],
        [ 'ふりがな-2', 'furi_2' ],
        [ '生年月日', 'birthday' ],
        [ '学校種別', 'school_type' ],
        [ 'お子さまの園名・学校名', 'school_name' ],
        [ '小・中学校', 'school_suffix' ],
  
        // ２人目：教材について
        [ 'c2-月刊ポピー', 'c2popy' ],
        [ 'c2-ポピーKidsEnglish[data]', 'c2pke' ],
  
        // ２人目：お子様について
        [ 'c2-お名前-1', 'c2name_1' ],
        [ 'c2-お名前-2', 'c2name_2' ],
        [ 'c2-ふりがな-1', 'c2furi_1' ],
        [ 'c2-ふりがな-2', 'c2furi_2' ],
        [ 'c2-生年月日', 'c2birthday' ],
        [ 'c2-学校種別', 'c2school_type' ],
        [ 'c2-お子さまの園名・学校名', 'c2school_name' ],
        [ 'c2-小・中学校', 'c2school_suffix' ],

        // 保護者さまについて
        [ '保護者-お名前-1', 'p_name_1' ],
        [ '保護者-お名前-2', 'p_name_2' ],
        [ '保護者-ふりがな-1', 'p_furi_1' ],
        [ '保護者-ふりがな-2', 'p_furi_2' ],
        [ '郵便番号', 'zip' ],
        [ '都道府県', 'pref' ],
        [ '市区町村番地', 'addr' ],
        [ '建物名部屋番号', 'bldg' ],
        [ 'メール', 'email' ],
        [ '電話番号', 'phone' ],

        // アンケート
        [ 'アンケート', 'enquete' ],
        [ '紹介者名', 'popy_agent' ],
      ]
    }
  },
  mounted () {

    // デフォルト選択
    if( is_input ){
      // this.$el.querySelector('input[type="radio"][name="開始月号"]').checked = true
      // this.$el.querySelector('input[type="radio"][name="c2-開始月号"]').checked = true
      // this.formdata.start = this.$el.querySelector('input[type="radio"][name="開始月号"]:checked').value
      // this.formdata.c2start = this.$el.querySelector('input[type="radio"][name="c2-開始月号"]:checked').value
    }

    // カレンダーセット
    $(() => this.setDatepicker() )

    if( is_confirm && this.is_initial ){
      this.confirmInit()
    }
  },
  methods: {
    toggleSection (section) {
      if( this.is_child2 ){
        if( confirm('２人目の情報は送信されません。\nよろしいですか？') )
        this.$emit( 'toggle-section', section )
      }else{
        this.$emit( 'toggle-section', section )
      }
    },
    confirmInit () {
      // フォームの項目をインスタンスのデータにリアクティブ登録（ローカル・ルートインスタンス）
      this.inputs.forEach( v => this.$set( this.formdata, v[1] ) )
      this.$emit( 'upd-inputs', this.formdata )

      // インスタンスのデータに確認画面hidden old-valueを移動してold-valueを削除
      // old-valueはファイル上部のinit()にて退避している
      this.inputs.forEach( v => $(()=>{
        this.formdata[v[1]] = $(`input[type="hidden"][name="${v[0]}"]`, this.$el).attr('old-value')
        $(`input[type="hidden"][name="${v[0]}"]`, this.$el).removeAttr('old-value')
      }));

      // 状態管理
      [ 'is_child2' ].forEach( v => $(()=>{
        const $hidden = $(`input[name="${v}"][old-value]`, this.$el)
        const val = $hidden.attr('old-value') == 'true'? true: false
        $hidden.removeAttr('old-value')
        this.$emit('upd-state', v, val)
      }))

      // 初期設定完了をルートインスタンスに伝える
      this.$emit( 'initialized' )
    },
    setDatepicker () {
      // カレンダー
      $('input[type=text][name$="生年月日"]', this.$el).each( (i,obj) => {
        const endDate = new Date()
        const startDate = new Date()
        const defaultViewDate = new Date()

        // 生年月日範囲設定
        startDate.setFullYear( startDate.getFullYear() - 15 )
        defaultViewDate.setFullYear( defaultViewDate.getFullYear() - 2 )

        $(obj).datepicker({
          endDate, // today
          startDate,
          defaultViewDate,
          startView: 'decade',
          language: "ja",
          format: 'yyyy年mm月dd日',
          autoclose: true,
          container: 'body.page'
        })
      })
    },
    // 郵便番号検索ボタン
    getAjaxzip (e) {
      const target = e.target.dataset
      AjaxZip3.zip2addr( target.zip, '', target.pref, target.addr ); // eslint-disable-line no-undef
    },
  },
  computed: {
    childToggleBtn () {
      return this.is_child2 ? 'ひとり減らす': 'もうひとり追加'
    },
    school_suffix () {
      switch ( this.formdata.popy ){
        case 'ももちゃん':
        case 'きいどり':
        case 'あかどり':
        case 'あおどり':
          return ''

        case '小学ポピー1年生':  case '小学ポピー2年生':  case '小学ポピー3年生':
        case '小学ポピー4年生':  case '小学ポピー5年生':  case '小学ポピー6年生':
          this.formdata.school_suffix = '小学校'
          return '小学校'

        case '中学ポピー1年生':  case '中学ポピー2年生':  case '中学ポピー3年生':
          this.formdata.school_suffix = '中学校'
          return '中学校'

        default:
          return ''
      }
    },
    is_school () {
      switch ( this.formdata.popy ){
        case '小学ポピー1年生':  case '小学ポピー2年生':  case '小学ポピー3年生':
        case '小学ポピー4年生':  case '小学ポピー5年生':  case '小学ポピー6年生':
        case '中学ポピー1年生':  case '中学ポピー2年生':  case '中学ポピー3年生':
          return true
      }
      return false
    },
    c2school_suffix () {
      switch ( this.formdata.c2popy ){
        case 'ももちゃん':
        case 'きいどり':
        case 'あかどり':
        case 'あおどり':
          return ''

        case '小学ポピー1年生':  case '小学ポピー2年生':  case '小学ポピー3年生':
        case '小学ポピー4年生':  case '小学ポピー5年生':  case '小学ポピー6年生':
          this.formdata.c2school_suffix = '小学校'
          return '小学校'

        case '中学ポピー1年生':  case '中学ポピー2年生':  case '中学ポピー3年生':
          this.formdata.c2school_suffix = '中学校'
          return '中学校'

        default:
          return ''
      }
    },
    is_c2school () {
      switch ( this.formdata.c2popy ){
        case '小学ポピー1年生':  case '小学ポピー2年生':  case '小学ポピー3年生':
        case '小学ポピー4年生':  case '小学ポピー5年生':  case '小学ポピー6年生':
        case '中学ポピー1年生':  case '中学ポピー2年生':  case '中学ポピー3年生':
          return true
      }
      return false
    }
  }
})